var _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.68
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.6915 21.2244C1.28675 21.2244 0.962948 20.8871 1.00342 20.4823C1.3812 15.2879 5.71209 11.1864 11.0009 11.1864C16.2897 11.1864 20.6207 15.2879 20.9984 20.4823C21.0254 20.8871 20.7016 21.2244 20.3103 21.2244H1.6915Z",
    stroke: "white",
    strokeMiterlimit: 10
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.68
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.0009 11.1729C13.8101 11.1729 16.0874 8.89561 16.0874 6.08644C16.0874 3.27727 13.8101 1 11.0009 1C8.19174 1 5.91447 3.27727 5.91447 6.08644C5.91447 8.89561 8.19174 11.1729 11.0009 11.1729Z",
    stroke: "white",
    strokeMiterlimit: 10
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.b63c242695958488d83ad58129269e2d.svg";
export { ForwardRef as ReactComponent };